import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../user_and_auth/auth.service';

/**
 * Blocks an auth-only route. If the current JWT is expired we first try a
 * silent refresh using the stored refresh_token; only on failure do we
 * redirect to /login?returnUrl=<originally-requested-url>.
 */
export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const ok = await auth.ensureValidJwt();
  if (ok) return true;

  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
